import React, { useState, useRef, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  id: 1,
  icon: '📘',
  title: 'Tomo 1 — El Despertar de la Atención',
  image: 'https://cdn.magicpatterns.com/uploads/2vGVXCkSHsQ4pt53EnBwEc/PORT_TOMO_1.png'
}, {
  id: 2,
  icon: '📗',
  title: 'Tomo 2 — Creatividad al Límite',
  image: 'https://cdn.magicpatterns.com/uploads/hG7qBwf2u3XhFjjqAXb4VN/PORT_TOMO_2.png'
}, {
  id: 3,
  icon: '📙',
  title: 'Tomo 3 — Desafíos Numéricos',
  image: 'https://cdn.magicpatterns.com/uploads/hKDLfcS6Bqzpb5sgFLaamm/PORT_TOMO_3.png'
}, {
  id: 4,
  icon: '📕',
  title: 'Tomo 4 — Mundo de Palabras',
  image: 'https://cdn.magicpatterns.com/uploads/veLsTp2M8e94VwJXTV71w2/PORT_TOMO_4.png'
}, {
  id: 5,
  icon: '📓',
  title: 'Tomo 5 — Laboratorio de Emociones',
  image: 'https://cdn.magicpatterns.com/uploads/qzrpUzcSvoVqmMmQmfcUwz/PORT_TOMO_5.png'
}, {
  id: 6,
  icon: '📔',
  title: 'Tomo 6 — El Maestro del Tiempo',
  image: 'https://cdn.magicpatterns.com/uploads/ufagYQ1caBdKv4QEzdtALt/PORT_TOMO_6.png'
}];
export function TomosCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    const newScroll = direction === 'left' ? scrollRef.current.scrollLeft - scrollAmount : scrollRef.current.scrollLeft + scrollAmount;
    scrollRef.current.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const index = Math.round(scrollRef.current.scrollLeft / (cardWidth + gap));
    setActiveIndex(Math.min(index, tomos.length - 1));
  };
  return <section className="bg-dark-900 py-10 px-4 overflow-hidden" data-id="element-275">
      <div className="max-w-6xl mx-auto" data-id="element-276">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-cream text-center mb-6" data-id="element-277">
          📚 Lo que vas a recibir{' '}
          <span className="text-primary" data-id="element-278">(6 Tomos completos)</span>
        </motion.h2>

        <div className="relative" data-id="element-279">
          <button onClick={() => scroll('left')} className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-dark-800 border border-primary/40 rounded-full items-center justify-center text-cream hover:bg-primary/30 transition-colors shadow-lg" aria-label="Anterior" data-id="element-280">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-281" />
          </button>
          <button onClick={() => scroll('right')} className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-dark-800 border border-primary/40 rounded-full items-center justify-center text-cream hover:bg-primary/30 transition-colors shadow-lg" aria-label="Siguiente" data-id="element-282">
            <ChevronRightIcon className="w-6 h-6" data-id="element-283" />
          </button>

          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-284">
            {tomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} viewport={{
            once: true
          }} className="flex-shrink-0 snap-center w-[240px] md:w-[280px]" data-id="element-285">
                <div className="bg-gradient-to-b from-primary/20 to-dark-800 rounded-2xl border border-primary/30 overflow-hidden shadow-xl hover:border-primary transition-colors aspect-[3/4] flex flex-col" data-id="element-286">
                  {tomo.image ? <img src={tomo.image} alt={tomo.title} className="w-full h-full object-cover" loading="lazy" data-id="element-287" /> : <div className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-id="element-288">
                      <span className="text-6xl mb-4" data-id="element-289">{tomo.icon}</span>
                      <p className="text-cream text-base md:text-lg font-bold leading-tight" data-id="element-290">
                        {tomo.title}
                      </p>
                    </div>}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-4" data-id="element-291">
          {tomos.map((_, index) => <button key={index} onClick={() => {
          if (!scrollRef.current) return;
          const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
          const gap = 24;
          scrollRef.current.scrollTo({
            left: index * (cardWidth + gap),
            behavior: 'smooth'
          });
        }} className={`h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-primary w-6' : 'bg-cream/30 hover:bg-cream/50 w-2.5'}`} aria-label={`Ir a tomo ${index + 1}`} data-id="element-292" />)}
        </div>

        <p className="text-center text-cream/50 text-sm mt-2 md:hidden" data-id="element-293">
          Deslizá para ver todo 👉
        </p>
      </div>
    </section>;
}